import { ITeam } from "core-integration/src/store/teams/types";
import * as React from "react";
import styled from "styled-components";

const StyledBadge = styled.img`
  width: 100%;
  display: inline-block;
  vertical-align: middle;
`;

const badgePath = `/dist/img/badges`;
const prefix = "badge_";

interface IProps {
  isPresentation?: boolean;
  sizes: string;
  team: ITeam;
}

const Badge: React.FC<IProps> = ({ isPresentation, sizes, team }) => {
  const code = team.code || 0;
  const path = `${badgePath}/${prefix}${code}`;

  const imgProps = {
    alt: team.name,
    role: "",
    sizes,
    src: `${path}-50.png`,
    srcSet: `${path}-50.png 40w, ${path}-100.png 80w`,
  };

  if (isPresentation) {
    imgProps.alt = "";
    imgProps.role = "presentation";
  }

  return <StyledBadge {...imgProps} />;
};

export default Badge;
